import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TowerGroupDto, UserDto } from 'src/app/api/models';
import { NetworkState } from 'src/shared/models/enums';

@Injectable({
	providedIn: 'root'
})
export class EventsService {
	private usersSubject: Subject<any> = new Subject<any>();
	public $usersObs: Observable<any>;

	private paymentMethodsSubject: Subject<any> = new Subject<any>();
	public $paymentMethodsObs: Observable<any>;

	private profileSubject: Subject<any> = new Subject<any>();
	public $profileObs: Observable<any>;

	private groupsSubject: BehaviorSubject<Array<TowerGroupDto>> = new BehaviorSubject<Array<TowerGroupDto>>([]);
	public $groupsObs: Observable<Array<TowerGroupDto>>;

	private navbarStateSubject: Subject<any> = new Subject<any>();
	public $navbarStateObs: Observable<any>;

	private refreshBookingsSubject: Subject<any> = new Subject<any>();
	public $refreshBookingsObs: Observable<any>;

	private refreshSubscriptionSubject: Subject<any> = new Subject<any>();
	public $updateSubscriptionObs: Observable<any>;

	private updateGroupOnOpenedModalSubject: Subject<any> = new Subject<any>();
	public $updateGroupOnOpenedModalObs: Observable<any>;

	private updateNetworkStateSubject: Subject<any> = new Subject<any>();
	public $updateNetworkStateObs: Observable<any>;

	private paypalAuth: Subject<any> = new Subject<any>();
	public $paypalAuthObs: Observable<any>;

	private updateFreeHoursSubject: Subject<any> = new Subject<any>();
	public $updateFreeHoursObs: Observable<any>;

	private newsSubject: Subject<any> = new Subject<any>();
	public $updateNewsObs: Observable<any>;

	private notificationsSubject: Subject<any> = new Subject<any>();
	public $updateNotificationsObs: Observable<any>;

	private appResumeSubject: Subject<any> = new Subject<any>();
	public $appResumeObs: Observable<any>;

	private langUpdateSubject: Subject<any> = new Subject<any>();
	public $langUpdateObs: Observable<any>;

	private bookingTabSubject: Subject<any> = new Subject<any>();
	public $bookingTabObs: Observable<any>;

	private openNotificationSettingsSubject: Subject<any> = new Subject<any>();
	public $openNotificationSettingsObs: Observable<any>;

	private openDeleteProfileSubject: Subject<any> = new Subject<any>();
	public $openDeleteProfileObs: Observable<any>;

	constructor() {
		this.$usersObs = this.usersSubject.asObservable();
		this.$profileObs = this.profileSubject.asObservable();
		this.$navbarStateObs = this.navbarStateSubject.asObservable();
		this.$groupsObs = this.groupsSubject.asObservable();
		this.$refreshBookingsObs = this.refreshBookingsSubject.asObservable();
		this.$updateGroupOnOpenedModalObs = this.updateGroupOnOpenedModalSubject.asObservable();
		this.$updateNetworkStateObs = this.updateNetworkStateSubject.asObservable();
		this.$paypalAuthObs = this.paypalAuth.asObservable();
		this.$updateSubscriptionObs = this.refreshSubscriptionSubject.asObservable();
		this.$updateFreeHoursObs = this.updateFreeHoursSubject.asObservable();
		this.$updateNewsObs = this.newsSubject.asObservable();
		this.$updateNotificationsObs = this.notificationsSubject.asObservable();
		this.$appResumeObs = this.appResumeSubject.asObservable();
		this.$paymentMethodsObs = this.paymentMethodsSubject.asObservable();
		this.$langUpdateObs = this.langUpdateSubject.asObservable();
		this.$bookingTabObs = this.bookingTabSubject.asObservable();
		this.$openNotificationSettingsObs = this.openNotificationSettingsSubject.asObservable();
		this.$openDeleteProfileObs = this.openDeleteProfileSubject.asObservable();
	}

	next(val) {
		this.usersSubject.next(val);
	}

	updateProfile(user: UserDto) {
		this.profileSubject.next(user);
	}

	navbarStateChanged() {
		this.navbarStateSubject.next('');
	}

	updatePaymentMethods() {
		this.paymentMethodsSubject.next('');
	}

	updateGroups(groups) {
		this.groupsSubject.next(groups);
	}

	updateSubs() {
		this.refreshSubscriptionSubject.next('');
	}

	refreshBookings() {
		this.refreshBookingsSubject.next('refresh');
	}

	updateGroupOnOpenedModal(g) {
		this.updateGroupOnOpenedModalSubject.next(g);
	}

	updateNetworkState(state: NetworkState) {
		this.updateNetworkStateSubject.next(state);
	}

	updatePaypalAuth(status: 'success' | 'failed') {
		this.paypalAuth.next(status);
	}

	updateFreeHours() {
		this.updateFreeHoursSubject.next('');
	}

	updateNews() {
		this.newsSubject.next('');
	}

	updateNotifications() {
		this.notificationsSubject.next('');
	}

	updateAppResume() {
		this.appResumeSubject.next('');
	}

	langUpdate() {
		this.langUpdateSubject.next('');
	}

	updateBookingTab(type: string = 'booking') {
		this.bookingTabSubject.next(type);
	}

	openNotificationSettings() {
		this.openNotificationSettingsSubject.next('');
	}

	openDeleteProfile() {
		this.openDeleteProfileSubject.next('');
	}
}
